import React, { useContext, useEffect } from 'react';
import {
	Button,
	ChevronRight,
	ConfigNotStarted,
	ContentLoader,
	ContentWrapper,
	PageLead,
	Richtext,
	Typography,
	Wrapper,
	withLocalization,
} from '@adac-mp/components';
import {
	ITypeVignettesOrderManagementFields,
	OfferContext,
	VignetteContext,
	getUrlBasePath,
	getUuidSentCollection,
	setRouteLangParam,
} from '@adac-mp/shared';
import { trackFunnelView } from '@adac-mp/components/src/utils/tracking/tracking';
import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

const CancelOrderRequestComponent = () => {
	const navigate = useNavigate();
	const { cancelFormData, lang, updateCancelFormData } = useContext(OfferContext);
	const { updateContentfulLabels, contentfulLabels } = useContext(VignetteContext);

	const { error, data, loading } = useQuery(getUuidSentCollection, {
		variables: { lang: lang || 'de' },
	});

	useEffect(() => {
		if (!error) {
			updateContentfulLabels(data?.vignettesOrderManagementCollection.items[0]);
		}
	}, [data]);

	const currentLabels = contentfulLabels as ITypeVignettesOrderManagementFields;

	useEffect(() => {
		const currCancelFormData = sessionStorage.getItem('cancelationDetails');
		trackFunnelView({
			label: currentLabels?.uuidSentHeadline || 'Bestätigen Sie Ihre Daten',
			element: 'Daten bestätigen',
			trackOnce: true,
		});
		if (!currCancelFormData) {
			navigate(getUrlBasePath(`cancel-order/vignette${setRouteLangParam(lang)}`), { replace: true });
		} else {
			updateCancelFormData(JSON.parse(currCancelFormData));
		}
	}, []);
	return (
		<>
			{loading ? (
				<ContentLoader isLoading hasPortal={false} />
			) : (
				<>
					<Wrapper className="bg-white items-center min-h-[calc(100vh_-_56px)] sm:min-h-[calc(100vh_-_98px)]">
						<ContentWrapper className="text-center">
							<PageLead
								icon={<ConfigNotStarted />}
								headline={currentLabels?.uuidSentHeadline || 'Bestätigen Sie Ihre Daten'}
								description={
									currentLabels?.uuidSentText ? (
										<Richtext
											document={currentLabels?.uuidSentText}
											replaceText={cancelFormData?.email}
										/>
									) : (
										<>
											<span className="inline-block mb-3">
												Wir haben Ihnen an{' '}
												<span className="font-bold">{cancelFormData?.email}</span> eine E-Mail
												mit Ihrem persönlichen Zugangslink gesendet. Dieser ist 15 Minuten
												gültig.
											</span>
											<span className="inline-block">
												Bitte prüfen Sie Ihr E-Mail Postfach und folgen Sie dem Zugangslink in
												der E-Mail. Prüfen Sie ggf. auch Ihren Spam-Ordner.
											</span>
										</>
									)
								}
							/>
							<>
								<Typography color="lightText" component="p" className="text-center">
									{currentLabels?.uuidSentMissingEmail || 'Sie haben keine E-Mail erhalten?'}
								</Typography>
								<Button
									className="gap-1.5 w-fit bg-white self-center group"
									variant="tertiary"
									tracking={{
										interaction_click: {
											label: 'Email erneut senden',
											element: 'Daten bestätigen',
										},
									}}
									onClick={() => {
										navigate(getUrlBasePath(`/cancel-order/vignette${setRouteLangParam(lang)}`));
									}}>
									<ChevronRight
										className="group-hover:[&>*]:fill-gray-100"
										fill="#3D3D3D"
										size="20"
									/>
									{currentLabels?.tryAgainText || 'Erneut versuchen'}
								</Button>
							</>
						</ContentWrapper>
					</Wrapper>
				</>
			)}
		</>
	);
};

export const CancelOrderRequest = withLocalization(CancelOrderRequestComponent);
